import { useLocation } from 'react-router-dom';
import { useAppSelector } from '../../../app/hooks';
import { getHashPathName } from '../helpers/helper';

export function usePathName(raw = false): string {
  const base = useAppSelector((state) => state.base);
  const location = useLocation();
  const hash = window.location.hash;
  const { pathname: locationPathname } = location;

  if (base.routeType === 'hash') {
    return getHashPathName(raw, hash);
  } else {
    return locationPathname;
  }
}

export type TypeUseNormalizeAssetPathHook = (path: string) => string;

export function useNormalizeAssetPath(): TypeUseNormalizeAssetPathHook {
  const base = useAppSelector((state) => state.base);

  function t(path: string): string {
    if (window.location.href.includes('localhost')) {
      path = './' + path;
    }

    return base.applicationType === 'fox' && base.assetPathPrefix !== undefined ? base.assetPathPrefix + path : path;
  }

  return t;
}
